import { useMemo } from 'react';

import { GeneratedPrivateLink } from '../../../types/generated';
import { shopifyGraphqlIdToAdminId } from '../../../utils/shopifyIds';
import { PrivateLinkProduct } from '../../private-sales/types/PrivateLink';
import { productCTAState } from '../../private-sales/utils';
import { buildPrivateRoomQuery } from '../utils/privateRoomQuery';

const ROOM_RELEASES = ['draw', 'private', 'public', 'timed'];

type UsePrivateRoomCheckoutLinkArgs = {
  privateLink: GeneratedPrivateLink;
  privateLinkProduct: PrivateLinkProduct;
};

export const usePrivateRoomCheckoutLink = ({
  privateLink,
  privateLinkProduct,
}: UsePrivateRoomCheckoutLinkArgs): string | null => {
  return useMemo(() => {
    if (productCTAState(privateLinkProduct) !== 'AVAILABLE') {
      return null;
    }

    if (
      !ROOM_RELEASES.includes(privateLinkProduct.shopifyProduct.releaseType)
    ) {
      return null;
    }

    const query = buildPrivateRoomQuery({
      slug: privateLink.slug,
      variantId: shopifyGraphqlIdToAdminId(privateLinkProduct.shopifyVariantId),
    });

    return `/checkout/${privateLinkProduct.slug}?${query}`;
  }, [privateLink.slug, privateLinkProduct]);
};
